import React, { useEffect, useState } from "react";
import {
  Stack,
  Typography,
  FormGroup,
  FormControlLabel,
  Button,
  Checkbox,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Navigate, useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import routesData from "../shared copy/routes.json";
import {
  stageDetailsAPICall,
  startOverAPICall,
  termsAndConditionsAPICall,
} from "../shared copy/APICalls";
import { ITermsandConditions } from "../shared copy/dtos";
import { checkUserLoggedIn } from "../shared copy/commonfunctions";
import StageLayout from "../Layouts/StageLayout";
import Styles from "../pages copy/Styles/TermsandConditions.module.scss";
import image from "../Components copy/assets/Images/TCImage.svg";
import icon from "../Components copy/assets/Images/iconnew.svg";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import TickCircle from "../Components copy/assets/Images/tick-circle.svg";
import StartOverBackDrop from "../Components copy/StartOverBackDrop";
import BackDrop from "../Components copy/BackDrop";
import Dropdown from "../Components copy/SelectDropdown/DropDown";

const TradingPreferenceSchema = Yup.object().shape({
  tariff: Yup.boolean().oneOf([true], "tariff is required"),
  condition1: Yup.boolean().oneOf([true], "Accept the condition"),
  condition2: Yup.boolean().oneOf([true], "Accept the condition"),
  condition3: Yup.boolean().oneOf([true], "Accept the condition"),
  condition4: Yup.boolean().oneOf([true], "Accept the condition"),
});

const Settlements = [
  {
    id: "quarter",
    sequence: 1,
    value: "Quarterly",
  },
  {
    id: "month",
    sequence: 2,
    value: "Monthly",
  },
];

export default function TermsandConditionsPage() {
  const [startOverloading, setstartOverloading] = useState(false);
  const [loading, setloading] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [completedStages, setCompletedStages] = useState<any>();
  const [backdrop, setBackDrop] = useState(false);
  const [prefilloading, setprefilloading] = useState(true);
  const [dropDownValue, setDropDownValue] = useState<any>(Settlements[0]);
  const navigate = useNavigate();
  const navigationData: any = routesData;
  const [prefilldata, setprefillData] = useState({
    condition1: true,
    condition2: true,
    condition3: true,
    condition4: true,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    checkUserLoggedIn(navigate);

    let obj: any = {
      stage: "t_and_c",
    };

    stageDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        setCompletedStages(responseData.completed_stages);

        setTimeout(() => {
          setprefilloading(false);
        }, 500);

        // console.log("responseData", responseData.data.StageDetails.TandC);
        if (responseData.data.StageDetails.TandC === true) {
          setprefillData((prev) => {
            // console.log("prev", prev);
            return {
              ...prev,
              condition1: true,
              condition2: true,
              condition3: true,
              condition4: true,
            };
          });

          setSelectAll(true);
        }
        if (responseData.data.StageDetails.SettlementPreference) {
          const preferenceType = Settlements.filter((data) =>
            data.id.includes(
              responseData.data.StageDetails.SettlementPreference
            )
          )[0];
          setDropDownValue(preferenceType);
        }
      })
      .catch((error: any) => {
        // console.log("error", error);
        setprefilloading(false);
      });
  }, []);

  function termsAndConditions() {
    setloading(true);
    let obj: ITermsandConditions = {
      is_t_and_c: true,
    };

    termsAndConditionsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        // console.log("responseData", response);
        setloading(false);
        if (
          responseData.data.stage &&
          navigationData.hasOwnProperty(responseData.data.stage)
        ) {
          navigate(navigationData[responseData.data.stage]);
        }
      })
      .catch((error: any) => {
        setloading(false);
      });
  }

  const handleStartOver = () => {
    if (
      window.confirm(
        "Are you sure you want to restart, on pressing Yes all the Data will be deleted"
      )
    ) {
      setBackDrop(true);
      setstartOverloading(true);
      startOverAPICall()
        .then((response: any) => {
          const responseData = response.data;
          // console.log("responseData", response);
          setstartOverloading(false);
          setBackDrop(false);
          navigate("/mobile");
          window.location.reload();
        })
        .catch((error: any) => {
          setBackDrop(false);
          setstartOverloading(false);
        });
    }
  };

  const handleSelectAllChange = (event: any, setFieldValue: any) => {
    const { checked } = event.target;
    setSelectAll(checked);

    setFieldValue("condition1", checked);
    setFieldValue("condition2", checked);
    setFieldValue("condition3", checked);
    setFieldValue("condition4", checked);
  };

  const handleChangeSelectChange = (event: any) => {
    setDropDownValue(event.target.value);
  };

  const InitialValues = {
    condition1: prefilldata.condition1,
    condition2: prefilldata.condition2,
    condition3: prefilldata.condition3,
    condition4: prefilldata.condition4,
  };
  // console.log("prefilldata1", prefilldata, InitialValues);
  return (
    <div className={Styles.mainWrapperTop}>
      <StageLayout
        completedStages={completedStages}
        stageName={"Terms & Conditions"}
        navigatePath={"/yourprofile"}
      />
      <div className={Styles.wrapper}>
        <div className={Styles.leftContainer}>
          {!prefilloading ? (
            <Formik
              initialValues={InitialValues}
              validationSchema={TradingPreferenceSchema}
              onSubmit={(values) => {
                // console.log(values);

                termsAndConditions();
              }}
            >
              {({ values, errors, touched, setFieldValue }) => {
                // console.log("values", values);
                {
                  values.condition1 &&
                  values.condition2 &&
                  values.condition3 &&
                  values.condition4
                    ? setSelectAll(true)
                    : setSelectAll(false);
                }
                return (
                  <Form>
                    <div>
                      <div className={Styles.mainContainer}>
                        <div className={Styles.headerSection}>
                          <p className={Styles.signup}>
                            Declarations For Your Trading Account
                          </p>
                          <p className={Styles.subText}>
                            By pressing continue, you acknowledge and confirm
                            that the information provided by you is true &
                            Correct.
                          </p>
                        </div>
                        <div className={Styles.contentContaineWrapper}>
                          <div className={Styles.contentContainer}>
                            <div className={Styles.checkBoxDiv}>
                              <FormGroup>
                                <FormControlLabel
                                  sx={{ alignItems: "flex-start" }}
                                  control={
                                    <Checkbox
                                      name="selectAll"
                                      checked={selectAll}
                                      sx={{
                                        padding: "0px",
                                        display: "none",
                                        //marginBottom: "15px",
                                      }}
                                      onChange={(event) =>
                                        handleSelectAllChange(
                                          event,
                                          setFieldValue
                                        )
                                      }
                                      icon={<PanoramaFishEyeIcon />}
                                      checkedIcon={
                                        <img src={TickCircle} width={"24px"} />
                                      }
                                    />
                                  }
                                  label={
                                    <span className={Styles.label}>
                                      {/* Select All */}
                                    </span>
                                  }
                                />
                              </FormGroup>
                            </div>
                            <div className={Styles.checkBoxDiv}>
                              <FormGroup>
                                <FormControlLabel
                                  sx={{ alignItems: "flex-start" }}
                                  control={
                                    <Checkbox
                                      name="condition1"
                                      checked={selectAll || values.condition1}
                                      icon={<PanoramaFishEyeIcon />}
                                      checkedIcon={
                                        <img src={TickCircle} width={"24px"} />
                                      }
                                      sx={{ padding: "0px", display: "none" }}
                                      onChange={(event) => {
                                        const { checked } = event.target;
                                        setFieldValue("condition1", true);
                                      }}
                                    />
                                  }
                                  label={
                                    <span className={Styles.label}>
                                      1. My sole country of tax residency is
                                      India. I / We have understood the
                                      information requirements of this Form
                                      (read along with the{" "}
                                      <a
                                        href="https://www.thefirstock.com/terms_and_conditions.html"
                                        target="_blank"
                                        className={Styles.aTag}
                                      >
                                        FATCA & CRS Instructions
                                      </a>
                                      ) and hereby confirm that the information
                                      provided by me/us on this Form is true,
                                      correct, and complete. I / We also confirm
                                      that I / We have read and understood the
                                      FATCA & CRS Terms and Conditions below and
                                      hereby accept the same. Name for your
                                      account will be updated as per the Income
                                      Tax database due to Exchange regulations.
                                    </span>
                                  }
                                />
                              </FormGroup>
                              {errors.condition1 && touched.condition1 && (
                                <Typography variant="body2" color="error">
                                  {errors.condition1}
                                </Typography>
                              )}
                            </div>
                            <div className={Styles.checkBoxDiv}>
                              <FormGroup>
                                <FormControlLabel
                                  sx={{ alignItems: "flex-start" }}
                                  control={
                                    <Checkbox
                                      name="condition2"
                                      sx={{ padding: "0px", display: "none" }}
                                      checked={selectAll || values.condition2}
                                      icon={<PanoramaFishEyeIcon />}
                                      checkedIcon={
                                        <img src={TickCircle} width={"24px"} />
                                      }
                                      onChange={(event) => {
                                        const { checked } = event.target;
                                        setFieldValue("condition2", true);
                                      }}
                                    />
                                  }
                                  label={
                                    <span className={Styles.label}>
                                      2. I authorise NCO Securities to operate
                                      the movement of securities from my demat
                                      account for any obligation created at the
                                      Exchange through my order(s)/trade(s) as
                                      per the{" "}
                                      <a
                                        href="https://www.thefirstock.com/terms_and_conditions.html"
                                        target="_blank"
                                        className={Styles.aTag}
                                      >
                                        Terms & Conditions
                                      </a>{" "}
                                      of the Online Delivery Instruction.
                                    </span>
                                  }
                                />
                              </FormGroup>
                              {errors.condition2 && touched.condition2 && (
                                <Typography variant="body2" color="error">
                                  {errors.condition2}
                                </Typography>
                              )}
                            </div>
                            <div className={Styles.checkBoxDiv}>
                              <FormGroup>
                                <FormControlLabel
                                  sx={{ alignItems: "flex-start" }}
                                  control={
                                    <Checkbox
                                      name="condition3"
                                      sx={{ padding: "0px", display: "none" }}
                                      checked={selectAll || values.condition3}
                                      icon={<PanoramaFishEyeIcon />}
                                      checkedIcon={
                                        <img src={TickCircle} width={"24px"} />
                                      }
                                      onChange={(event) => {
                                        const { checked } = event.target;
                                        setFieldValue("condition3", true);
                                      }}
                                    />
                                  }
                                  label={
                                    <span className={Styles.label}>
                                      3. I confirm and understand that my name
                                      as per the IT Department will be taken as
                                      my default NCO Securities account name, in
                                      case there is any mismatch of my name as
                                      per the IT department and my name as per
                                      the KRA database/Aadhaar/Bank account. I
                                      further confirm that the linked bank
                                      accounts, Aadhaar, and PAN belong to me.
                                    </span>
                                  }
                                />
                              </FormGroup>
                              {errors.condition3 && touched.condition3 && (
                                <Typography variant="body2" color="error">
                                  {errors.condition3}
                                </Typography>
                              )}
                            </div>

                            <div className={Styles.checkBoxDiv}>
                              <FormGroup>
                                <FormControlLabel
                                  sx={{ alignItems: "flex-start" }}
                                  control={
                                    <Checkbox
                                      name="condition4"
                                      sx={{ padding: "0px", display: "none" }}
                                      checked={selectAll || values.condition4}
                                      icon={<PanoramaFishEyeIcon />}
                                      checkedIcon={
                                        <img src={TickCircle} width={"24px"} />
                                      }
                                      onChange={(event) => {
                                        const { checked } = event.target;
                                        setFieldValue("condition4", true);
                                      }}
                                    />
                                  }
                                  label={
                                    <span className={Styles.label}>
                                      4. I confirm to have read and understood
                                      the contents of the{" "}
                                      <a
                                        href="https://www.thefirstock.com/terms_and_conditions.html"
                                        target="_blank"
                                        className={Styles.aTag}
                                      >
                                        Equity Annexure
                                      </a>{" "}
                                      documents.
                                      {/* which include the below annexures:
                                    <span
                                      style={{
                                        color: "#05603A",
                                        padding: "0 3px",
                                        fontWeight: 600,
                                      }}
                                    >
                                      90days
                                    </span>{" "} */}
                                    </span>
                                  }
                                />
                              </FormGroup>
                              {errors.condition4 && touched.condition4 && (
                                <Typography variant="body2" color="error">
                                  {errors.condition4}
                                </Typography>
                              )}
                            </div>
                            <div className={Styles.checkBoxDiv}>
                              <FormGroup>
                                <FormControlLabel
                                  sx={{ alignItems: "flex-start" }}
                                  control={
                                    <Checkbox
                                      name="condition3"
                                      sx={{ padding: "0px", display: "none" }}
                                      checked={selectAll || values.condition3}
                                      icon={<PanoramaFishEyeIcon />}
                                      checkedIcon={
                                        <img src={TickCircle} width={"24px"} />
                                      }
                                      onChange={(event) => {
                                        const { checked } = event.target;
                                        setFieldValue("condition3", true);
                                      }}
                                    />
                                  }
                                  label={
                                    <span className={Styles.label}>
                                      <span>
                                        {" "}
                                        5. I Confirm to take the settlement of
                                        my unused funds on every{" "}
                                      </span>
                                      <FormControl size="small">
                                        <Select
                                          style={{ width: "75px" }}
                                          inputProps={{
                                            IconComponent: () => "",
                                          }}
                                          disableUnderline
                                          sx={{
                                            fontSize: "14px",

                                            color: "#475467",
                                            fontWeight: 600,
                                            boxShadow: "none",
                                            ".MuiSvgIcon-root-393": {
                                              visibility: "hidden",
                                            },
                                            ".MuiOutlinedInput-input": {
                                              padding: "3.5px 5px !important",
                                            },
                                            ".MuiOutlinedInput-notchedOutline":
                                              {
                                                border: 0,
                                              },
                                            "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                              {
                                                border: 0,
                                              },
                                            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                              {
                                                border: 0,
                                              },
                                          }}
                                          labelId="demo-simple-select-label"
                                          id="demo-simple-select"
                                          value={dropDownValue}
                                          label=""
                                          onChange={(event) => {
                                            handleChangeSelectChange(event);
                                          }}
                                        >
                                          {Settlements.map(
                                            (data: any, index: any) => {
                                              // console.log(data)
                                              return (
                                                <MenuItem
                                                  value={data}
                                                  key={index}
                                                >
                                                  {data.value}
                                                </MenuItem>
                                              );
                                            }
                                          )}
                                        </Select>
                                      </FormControl>
                                      basis from my NCO securities trading
                                      account.
                                    </span>
                                  }
                                />
                              </FormGroup>
                              {errors.condition3 && touched.condition3 && (
                                <Typography variant="body2" color="error">
                                  {errors.condition3}
                                </Typography>
                              )}
                            </div>
                          </div>
                          <div className={Styles.imageContainer}>
                            <img src={image} className={Styles.image} />
                          </div>
                        </div>
                      </div>

                      {backdrop && <StartOverBackDrop />}
                      <div className={Styles.buttonStack}>
                        <div>
                          {(values.condition1 &&
                            values.condition2 &&
                            values.condition3 &&
                            values.condition4) ||
                          selectAll ? (
                            <LoadingButton
                              variant="contained"
                              type="submit"
                              loading={loading}
                              id="termsandconditionsContinueButton"
                              className={Styles.approveButton}
                            >
                              Continue
                            </LoadingButton>
                          ) : (
                            <Button
                              variant="contained"
                              type="submit"
                              disabled
                              className={Styles.approveButton}
                            >
                              Continue
                            </Button>
                          )}
                        </div>
                        <div className={Styles.startOverSection}>
                          <img src={icon} className={Styles.iconImage} />
                          <p className={Styles.paratext}>
                            {" "}
                            if the above mentioned info not yours
                            <span
                              className={Styles.startoverbutton}
                              onClick={handleStartOver}
                            >
                              Start Over
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          ) : (
            <div style={{ height: "100vh" }}>
              <BackDrop />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
